<template>
	<div>
		<toast></toast>
		<div class="col-md-4 pt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||!clickToggle),'d-none':!specail&&(viewToggle||!clickToggle)}">
			<div class="centre_content consult_left">
                <div id="consult_left_content" class="pl-3" >
                    <i class="fa fa-mortar-board fa-lg mr-2"></i>Consulting Service
                    <span class="myBtn" @click='goback()' v-if="!viewToggle">Investment Adviser</span>
                </div>
				<div class="row nano one_title_nano m-0">
					<div class="nano-content" id="home_left_list" :class="{'cur':!viewToggle}">
						<ul class="list-unstyled consulList">
							<li v-for='(value,key) in particulars' class="media pb-3 pt-3 pl-4 pr-3 border-bottom mb-3" style="position: relative;">
								<router-link :to="{name:'consultorganization',params :{contentid:value.id}}" class="w-100" style="display: contents;">

									<img v-if="value.thumb != ''" :src="value.thumb" class="mr-3 img-thumbnail" style="width:30%;float:left;max-width: 30%;" />

									<div class="media-body" :class="{'sanliul':issan}" style="float: left;width:60%">
										<h5 class=""><a href="javascript:" class="f15 font-weight-bold" target="_blank">{{value.title}}</a></h5>
                                        <div  class="media-foot f13 mt-3 mb-3 font-weight-light text-muted">
                                            <span>{{ value.description}}</span>
                                        </div>
                                        <div class="media-foot mt-1 font-weight-light f12">
											<span class="">
												<img :src="value.space.photo" class="rounded-circle" style="width: 30px;height: 30px;">
											</span>
											<span class="p-1">{{value.space.name}}</span>
											<!--<span class="organization p-1">{{value.space.type}}</span>-->
											<span class="p-1">{{value.published}}</span>
										</div>
									</div>
								</router-link>
							</li>

							<p class="text-center p-2" v-if="contentLoadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
							<p class="text-center p-2" v-if="contentEndShow">loading...</p>
						</ul>
					</div>
				</div>

			</div>
		</div>
		<div class="col-md-8 pl-0 mt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||clickToggle),'d-none':!specail&&(viewToggle||clickToggle)}">
			<div class="right_content_show" style="background-color: white;box-shadow: 0 4px 10px 0 rgba(0,0,0,.1);">
                <div id="consult_left_content" class="pl-3" v-if="!viewToggle">
                    <i class="fa fa-mortar-board fa-lg mr-2"></i>Consulting Service
                    <span class="myBtn" @click='goback()'>Popular Viewpoint</span>
                </div>
				<!-- <ul class="list-group" style="box-shadow: 0 1px 5px 0 rgba(0,0,0,0.05);">
					<li class="list-group-item consult_classify" style="border: none;">
						<span v-for="(value,key) in tylelists" @click="msgs(value.id)" :rel="value.id" :class="{'consult_classify_active':msg == value.id}">{{value.name}}</span>

					</li>
					<li class="list-group-item" style="border:none;border-top:1px solid rgba(0,0,0,.125);border-radius:0px;">
						<ul v-show="msg==1" class="row guan">
							<li v-for="(value,key) in consultlists" class="text-center m-2" style="width: auto;min-width: 10%;" :class="{'consult_classify_actives':isCctive == value.sid}" @click="journalistclassify(value.sid)">
								<a href="javascript:" :rel="value.sid">{{value.name}}</a>
							</li>
						</ul>
						<ul v-show="msg==2" style="padding-left: 0px">
							<div class="d-flex flex-wrap letter_list guans">
								<a href="javasrcipt:;" rel="a">
									<li @click="recommend('a')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='a'}">
										<a href="javasrcipt:;" rel="a">A</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="b">
									<li @click="recommend('b')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='b'}">
										<a href="javasrcipt:;" rel="b">B</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="c">
									<li @click="recommend('c')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='c'}">
										<a href="javasrcipt:;" rel="c">C</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="d">
									<li @click="recommend('d')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='d'}">
										<a href="javasrcipt:;" rel="d">D</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="e">
									<li @click="recommend('e')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='e'}">
										<a href="javasrcipt:;" rel="e">E</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="f">
									<li @click="recommend('f')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='f'}">
										<a href="javasrcipt:;" rel="f">F</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="g">
									<li @click="recommend('g')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='g'}">
										<a href="javasrcipt:;" rel="g">G</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="h">
									<li @click="recommend('h')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='h'}">
										<a href="javasrcipt:;" rel="h">H</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="i">
									<li @click="recommend('i')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='i'}">
										<a href="javasrcipt:;" rel="i">I</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="j">
									<li @click="recommend('j')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='j'}">
										<a href="javasrcipt:;" rel="j">J</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="k">
									<li @click="recommend('k')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='k'}">
										<a href="javasrcipt:;" rel="k">K</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="l">
									<li @click="recommend('l')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='l'}">
										<a href="javasrcipt:;" rel="l">L</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="m">
									<li @click="recommend('m')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='m'}">
										<a href="javasrcipt:;" rel="m">M</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="n">
									<li @click="recommend('n')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='n'}">
										<a href="javasrcipt:;" rel="n">N</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="o">
									<li @click="recommend('o')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='o'}">
										<a href="javasrcipt:;" rel="o">O</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="p">
									<li @click="recommend('p')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='p'}">
										<a href="javasrcipt:;" rel="p">P</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="q">
									<li @click="recommend('q')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='q'}">
										<a href="javasrcipt:;" rel="q">Q</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="r">
									<li @click="recommend('r')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='r'}">
										<a href="javasrcipt:;" rel="r">R</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="s">
									<li @click="recommend('s')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='s'}">
										<a href="javasrcipt:;" rel="s">S</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="t">
									<li @click="recommend('t')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='t'}">
										<a href="javasrcipt:;" rel="t">T</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="u">
									<li @click="recommend('u')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='u'}">
										<a href="javasrcipt:;" rel="u">U</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="v">
									<li @click="recommend('v')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='v'}">
										<a href="javasrcipt:;" rel="v">V</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="w">
									<li @click="recommend('w')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='w'}">
										<a href="javasrcipt:;" rel="w">W</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="x">
									<li @click="recommend('x')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='x'}">
										<a href="javasrcipt:;" rel="x">X</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="y">
									<li @click="recommend('y')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='y'}">
										<a href="javasrcipt:;" rel="y">Y</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="z">
									<li @click="recommend('z')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='z'}">
										<a href="javasrcipt:;" rel="z">Z</a>
									</li>
								</a>
							</div>

						</ul>
						<ul v-show="msg==3" style="padding-left: 0px">
							<div class="d-flex flex-wrap letter_list guanes">
								<a href="javasrcipt:;" rel="a">
									<li @click="recommend('a')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='a'}">
										<a href="javasrcipt:;" rel="a">A</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="b">
									<li @click="recommend('b')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='b'}">
										<a href="javasrcipt:;" rel="b">B</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="c">
									<li @click="recommend('c')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='c'}">
										<a href="javasrcipt:;" rel="c">C</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="d">
									<li @click="recommend('d')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='d'}">
										<a href="javasrcipt:;" rel="d">D</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="e">
									<li @click="recommend('e')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='e'}">
										<a href="javasrcipt:;" rel="e">E</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="f">
									<li @click="recommend('f')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='f'}">
										<a href="javasrcipt:;" rel="f">F</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="g">
									<li @click="recommend('g')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='g'}">
										<a href="javasrcipt:;" rel="g">G</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="h">
									<li @click="recommend('h')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='h'}">
										<a href="javasrcipt:;" rel="h">H</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="i">
									<li @click="recommend('i')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='i'}">
										<a href="javasrcipt:;" rel="i">I</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="j">
									<li @click="recommend('j')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='j'}">
										<a href="javasrcipt:;" rel="j">J</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="k">
									<li @click="recommend('k')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='k'}">
										<a href="javasrcipt:;" rel="k">K</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="l">
									<li @click="recommend('l')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='l'}">
										<a href="javasrcipt:;" rel="l">L</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="m">
									<li @click="recommend('m')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='m'}">
										<a href="javasrcipt:;" rel="m">M</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="n">
									<li @click="recommend('n')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='n'}">
										<a href="javasrcipt:;" rel="n">N</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="o">
									<li @click="recommend('o')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='o'}">
										<a href="javasrcipt:;" rel="o">O</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="p">
									<li @click="recommend('p')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='p'}">
										<a href="javasrcipt:;" rel="p">P</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="q">
									<li @click="recommend('q')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='q'}">
										<a href="javasrcipt:;" rel="q">Q</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="r">
									<li @click="recommend('r')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='r'}">
										<a href="javasrcipt:;" rel="r">R</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="s">
									<li @click="recommend('s')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='s'}">
										<a href="javasrcipt:;" rel="s">S</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="t">
									<li @click="recommend('t')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='t'}">
										<a href="javasrcipt:;" rel="t">T</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="u">
									<li @click="recommend('u')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='u'}">
										<a href="javasrcipt:;" rel="u">U</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="v">
									<li @click="recommend('v')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='v'}">
										<a href="javasrcipt:;" rel="v">V</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="w">
									<li @click="recommend('w')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='w'}">
										<a href="javasrcipt:;" rel="w">W</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="x">
									<li @click="recommend('x')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='x'}">
										<a href="javasrcipt:;" rel="x">X</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="y">
									<li @click="recommend('y')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='y'}">
										<a href="javasrcipt:;" rel="y">Y</a>
									</li>
								</a>
								<a href="javasrcipt:;" rel="z">
									<li @click="recommend('z')" class="d-block rounded-circle text-center" :class="{'consult_classify_active':isActive=='z'}">
										<a href="javasrcipt:;" rel="z">Z</a>
									</li>
								</a>
							</div>
						</ul>
					</li>
				</ul> -->
				<ul class="nano counsel_institution consult_classify_list m-0 w-100">
					<div class="nano-content d-flex flex-wrap" id="home_right_list" :class="{'cur':!viewToggle}" style="padding: 20px">

						<div v-for="(value,$index) in spacelists" class="col-md-8 col-lg-6  p-3 col-my-33">
							<div class="card w-100 p-0 sm-w-100" style="border-radius:0px">

								<div class="card-body">
									<h5 class="card-title row" style="margin: 0;">

									    <span class="float-right w-100">

									    	<router-link :to ="{name:'consultdetails',params :{name:value.space.alias, contentid:0}}">
									    		<img v-if="value.space.photo != ''" :src="value.space.photo" :alt="value.space.name" class="rounded-circle float-left img-thumbnail" style="width: 80px;height: 80px;" />
									    		<img v-if="value.space.photo == ''" src="../../../assets/images/silkRoadBase/nohead.jpg" :alt="value.space.name" class="rounded-circle float-left img-thumbnail" style="width: 80px;height: 80px;" />
									    		<span class=" pl-3 mt-3" style="line-height: 25px;display: inline-block;">{{value.space.name}}</span>
									    	</router-link>
									    	<br/>

									    	<span class="f12 text-secondary pl-3 mt-2" v-if="msg!=3">{{value.space.tags}}</span>
									    </span>

									</h5>
									<div class="card-text pl-2 mybn" v-if="value.content != ''">
										Article：
										<router-link  v-for="(chind, index) in value.content" :to="{name:'consultorganization',params :{contentid:chind.id}}" class="w-100 d-flex" :key="index">
											<p class="text-secondary">
												{{chind.title}}
											</p>
										</router-link>
                                       <!-- <p class="text-secondary" v-if="value.content.length=0">
                                           暂无发表专文

                                        </p>-->
									</div>
                                    <div class="card-text pl-2" v-if="value.content == ''">
										Article：

                                         <p class="text-secondary" >
											 No published articles

                                         </p>
                                    </div>
								</div>
								<div class="row consult_subscription" style="margin-left: 0;margin-right: 0">
									<div @click="refer($event,value.space.spaceid,value.space.name)" class="col-md-6 col-6 offer" data-toggle="modal" data-target="#myModal" style="border-right: 1px solid #f4f5f6;">
										<i class="fa fa-comments-o mr-2"></i> Consulting Service
									</div>
									<div class="col-md-6 col-6 collectToggle" @click="subscription($event,value.space)" >
										<!--<i @click="subscription(value,$index,value.space.spaceid)" :class="{ 'startrue': value.checked }" class="fa fa-star-o mr-3"></i> 订阅-->
										<!--<i v-if="value.space.collect" @click="subscription($event,value.space.spaceid)" :class="{ 'startrue': isSelected }" class="fa fa-star-o mr-3 startrue"></i>
										<i v-if="!value.space.collect" @click="subscription($event,value.space.spaceid,value.space.attention,value.space)" :class="{ 'startrue': isSelected }" class="fa fa-star-o mr-3"></i>
                                        <span v-if="value.space.collect">已关注</span>
                                        <span v-if="!value.space.collect">关注</span>-->
                                        <i :class="{ 'startrue': value.space.collect }" class="fa fa-star-o mr-2"></i>
                                        <!--<i v-if="!value.space.collect"  :class="{ 'startrue': value.space.collect }" class="fa fa-star-o mr-3"></i>-->
                                        <span v-if="value.space.collect">Followed</span>
                                        <span v-if="!value.space.collect">Follow</span>
									</div>
								</div>
							</div>
						</div>

						<p class="text-center p-2 w-100" v-if="spaceLoadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
						<p class="text-center p-2 w-100" v-if="spaceEndShow">loading...</p>
					</div>
				</ul>
			</div>
		</div>

		<!-- 模态框 -->
		<div class="modal fade" id="myModal">
			<div class="modal-dialog">
				<div class="modal-content">

					<!-- 模态框头部 -->
					<div class="modal-header">
						<h4 class="modal-title">Consultation request for {{this.refsname}}</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>

					<!-- 模态框主体 -->
					<div class="modal-body">
						<form>
							<input type="hidden" :value="this.refsid">
							<div class="form-group row ml-0 mr-0">
								<label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>Title</label>
								<input type="text"  v-model="advisorytitle" class="col-md-6 form-control col-8">
							</div>
							<div class="form-group row ml-0 mr-0">
								<label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>Content</label>
								<textarea  v-model="advisorycontent" maxlength="400" class="form-control col-8">

						</textarea>
							</div>
							<div class="form-group row ml-0 mr-0">
								<label class="col-md-3 col-4 tc">Unit with demand</label>
								<input type="text" v-model="advisorycompany" class="col-md-6 form-control col-8">
							</div>
							<div class="form-group row ml-0 mr-0">
								<label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>User name</label>
								<input  type="text" v-model="advisoryname" class="col-md-6 form-control col-8">
							</div>
							<div class="form-group row ml-0 mr-0">
								<label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>Mobile number</label>
								<input  type="phone" v-model="advisoryphone" class="col-md-6 form-control col-8">
							</div>
							<div class="form-group row ml-0 mr-0">
								<label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>Email</label>
								<input  type="email" v-model="advisoryemail" class="col-md-6 form-control col-8">
							</div>
							<div class="form-group row ml-0 mr-0">
								<label class="col-md-3 col-4 tc">Address</label>
								<input  type="text" v-model="advisoryaddress" class="col-md-6  col-8">
							</div>
							<div class="form-group row ml-0 mr-0">
								<label class="col-md-3 col-4 tc">Verification Code</label>
								<input type="text" v-model="advisorycapat" placeholder="Verification Code" class="col-md-2 form-control col-8">
								<img @click='refresh()' :src="codeUrl" id="code" class="border ml-3" style="line-height: 38px;" alt="Verification Code" width="65px" height="38px">

							</div>
							<div class="w-100 tc mt-3 mb-3">
								<button @click.stop.prevent="advisorysub" class="btn btn-primary" style="width: 100px;">Save</button>
							</div>
						</form>
					</div>

				</div>
			</div>
		</div>

	</div>
</template>
<script>
	import  User from './user.js'
	import toast from './toast/Toast'
	export default({
		name: 'consult_particulars_organization',
		data: function() {
			return {
                codeUrl:"https://en.imsilkroad.com/api/pc/captcha/"+Date.parse(new Date()),
				msg: this.$route.params.type||1,
				isCctive: '',
				particulars: [],
				tylelists: [],
				consultlists: [],
				refsid: '',
				refsname: '',
				isActive: false,
				title: this.$route.params.id,
				spacelists: [],
				//咨询modal提交
				advisorytitle: '',
				advisorycontent: '',
				advisorycompany: '',
				advisoryname: '',
				advisoryphone: '',
				advisoryemail: '',
				advisoryaddress: '',
				isActive: 'a',
				isBctive: 'a',
				content_page: 1,
                content_page_size:15,
				content_total_page: 1,
                space_page: 1,
                space_page_size:15,
                space_total_page: 1,
				startrue: false, //收藏
				isSelected: false,
				advisorycapat: '',
                issan:false,
                viewToggle:true,
                clickToggle:true,
                specail:false, //特殊处理 小于544px
                screenWidth:"",
                contentLoadShow:true,
                contentEndShow:false,
                spaceLoadShow:true,
                spaceEndShow:false
			}
		},
		created: function() {
			var self = this;
            this.viewToggle=this.IsPC();
            if(self.IsPC()&&(document.body.clientWidth<=700)){
                self.specail=true
            }else{
                self.specail=false
            }
			let that = this;
            if(window.navigator.userAgent.indexOf('AppleWebKit') != -1){
                this.issan=true
            }

                this.$axios.post('/api/pc/getcontent', {
                    page: this.content_page,
                    pagesize: this.content_page_size
                }).then(data => {
                    var particular = data.data.data;
                    self.particulars = particular;
                    that.content_total_page = data.data.maxpage;
                    that.contentLoadShow = false;
                })

                this.$axios.post('/api/pc/tylelist').then(data => {
                    var tylelist = data.data.type; //选项
                    self.tylelists = tylelist;
                    var consultlist = data.data.subclass; //选项列表
                    consultlist[0].sid = self.isCctive;
                    self.consultlists = consultlist;

                    this.$axios.post('/api/pc/spacelist', {
                        typeid: this.$route.params.type || 1,
                        sid: consultlist[0].sid,
                        page: this.space_page
                    }).then(function (data) {
                        var spacelist = data.data.data;
                        self.spacelists = spacelist;
                        that.space_total_page = data.data.maxpage;
                        that.spaceLoadShow = false;
                    })
                })

		},
		mounted() {
			document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
			document.getElementById('home_left_list').addEventListener('scroll', this.Scrolles);
			this.load();
            const that = this;
            window.onresize = () => {
                return (() => {
                    that.screenWidth = document.body.clientWidth
                })()
            }
		},
		methods: {
            goback(){
                    this.clickToggle=!this.clickToggle;
            },
            refresh(){
                $("#code").attr("src","https://en.imsilkroad.com/api/pc/captcha/"+ Date.parse(new Date()));
            },
			msgs: function(e) {

				var fomtguan = $('.guan li:first-child a').attr('rel');

				this.msg = e;
				var sid = '';
				let that = this;
				if(e != 1) {
					sid = 'a';
				} else {
					sid = fomtguan;
				}
				this.space_page =1;
				this.$axios.post('/api/pc/spacelist', {
					typeid: e,
					sid: sid,
                    page:this.space_page
				}).then(data => {
					var spacelist = data.data.data;
					that.spacelists = spacelist;
					that.space_total_page = data.data.maxpage;
				})
			},
			Scrolles() {
				let that = this;
				var top = document.getElementById('home_left_list').scrollTop; // 滚动条到上面的距离
				var client = document.getElementById('home_left_list').clientHeight; // 可视区域的高度
				var all = document.getElementById('home_left_list').scrollHeight; // 总高度
				var self = this;
				if(((all - 20) < (top + client)) && !this.contentLoadShow) {
                    this.content_page++;
                    if (this.content_page > this.content_total_page) {
                        this.contentEndShow = true;
                        return;
                    }


                    this.contentLoadShow = true;
                    this.$axios.post('/api/pc/getcontent', {
                        page: this.content_page,
                        pagesize: this.content_page_size
                    }).then(function (data) {
                        var particulares = data.data.data;
                        //						self.particulars = particular;
                        JSON.stringify(particulares);
                        var new_particular = self.particulars.concat(particulares);
                        self.particulars = new_particular;
                        this.contentLoadShow = false
                    })
                }
			},
			handleScroll() {
				let that = this;
				var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
				var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
				var all = document.getElementById('home_right_list').scrollHeight; // 总高度
				var self = this;

				var category = $(".consult_classify .consult_classify_active").attr('rel');
				if(category == 1) {
					var district = $(".guan .consult_classify_actives").children('a').attr('rel');

				} else if(category == 2) {

					var district = $(".guans .consult_classify_active").children('a').attr('rel');

				} else {
					var district = $(".guanes .consult_classify_active").children('a').attr('rel');
				}
				if(((all - 20) < (top + client)) && !this.spaceLoadShow) {
					this.space_page++;
					if(this.space_page > this.space_total_page) {
					    this.spaceEndShow = true;
						return;
					}
					this.spaceLoadShow = true;
					this.$axios.post('/api/pc/spacelist', {
						typeid: category,
						page: this.space_page,
						sid: district,
					}).then(data => {
						var spacelist = data.data.data;
						JSON.stringify(spacelist);
						var new_spacelists = self.spacelists.concat(spacelist);
						self.spacelists = new_spacelists;
						self.spaceLoadShow = false;
					})
				}

			},
			refer: function(e, refid, refname) {
				this.refsid = refid;
				this.refsname = refname;
			},
			recommend: function(e) {
				let that = this;
				this.space_page=1;
				that.isActive = e;
                var type=this.msg==2?2:3;
				this.$axios.post('/api/pc/spacelist', {
					typeid: type,
					sid: e,
                    page:1
				}).then(data => {
					var spacelist = data.data.data;
                    that.space_total_page = data.data.maxpage;
					that.spacelists = spacelist;
				})
			},
			institution: function(e) {
				let that = this;
				that.isBctive = e;
                this.space_page=1;
				this.$axios.post('/api/pc/spacelist', {
					typeid: 3,
					sid: e,
                    page:1
				}).then(data => {
					var spacelist = data.data.data;
					that.spacelists = spacelist;
				})
			},
			advisorysub: function() {
				let that = this;
                var reg = 11 && /^1[3578]\d{9}$|^147\d{8}$/;
                var regEmail = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
                if(that.advisorytitle == '') {
                    $(".wrap").text('Title cannot be empty！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                } else if(that.advisorycontent == '') {
                    $(".wrap").text('Content cannot be empty！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                    if(that.advisorycontent.length>400) {
                        $(".wrap").text('Content length cannot exceed 400');
                        $(".wrap").show().delay(1500).hide(100);
                        return;
                    }
                }  else if(that.advisoryname == '') {
                    $(".wrap").text('Name cannot be empty！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                } else if(that.advisoryphone == '') {
                    $(".wrap").text('Mobile number cannot be empty！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                } else if(!reg.test(that.advisoryphone)) {
                    $(".wrap").text('Incorrect format of mobile number！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                } else if(that.advisoryemail == '') {
                    $(".wrap").text('Mailbox cannot be empty！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                }else if(!regEmail.test(that.advisoryemail)) {
                        $(".wrap").text('Incorrect mailbox format！');
                        $(".wrap").show().delay(1500).hide(100);
                        return;
                }
				var src = $('#code').attr('src');
				var tmp = src.substring(src.lastIndexOf('/') + 1).match(/[^\/]*$/)[0];
				that.$axios.post('/api/pc/consult', {
					memberid: that.loginId,
					spaceid: that.refsid,
					title: that.advisorytitle,
					content: that.advisorycontent,
					company: that.advisorycompany,
					name: that.advisoryname,
					phone: that.advisoryphone,
					email: that.advisoryemail,
					address: that.advisoryaddress,
					tmp: tmp,
                    captcha: that.advisorycapat
				}).then(data => {
                    if(data.data.state){
                        $(".wrap").text('Successful consultation！');
                        $(".wrap").show().delay(1500).hide(100);
                        $("#myModal").modal('hide');
                    }else{
                        $(".wrap").text(data.data.error);
                        $(".wrap").show().delay(1500).hide(100);
                    }
				})
			},
			journalistclassify: function(e) {
				let that = this;
				this.isCctive = e;
				this.space_page=1;
				this.$axios.post('/api/pc/spacelist', {
	    				typeid: 1,
					    sid: e,
                        page:1
				}).then(data => {
					var spacelist = data.data.data;
					that.spacelists = spacelist;

				})
			},
			//订阅
			subscription: function(e, cll) {

				let that = this;
				var acquirePitch = event.target.getAttribute("pitch");

				var el = e.target;
				//this.isSelected = !this.isSelected
				if($(el).parent().find('.fa-star-o').hasClass('startrue')) {

					this.$axios.post('/api/pc/delspacecollect', { //取消订阅
                        memberid: that.loginId,
						spaceid: cll.spaceid,
						typeid:cll.attention
					}).then(data => {
						if(data.data.state == true) {
							$(".wrap").text('Cancel collection succeeded');
							//$(el).find('i').removeClass('startrue');
							$(".wrap").show().delay(1500).hide(100);
                            if(cll){
                                cll.collect=!cll.collect;
                            }
						} else {
							$(".wrap").text(data.data.error);
							$(".wrap").show().delay(1500).hide(100);
						}
					})

				} else {
					this.$axios.post('/api/pc/spacecollect', { //添加订阅
						memberid: that.loginId,
						spaceid: cll.spaceid,
						typeid:cll.attention
					}).then(data => {
						if(data.data.state == true) {
							$(".wrap").text('Collection success');
							//$(el).find('i').addClass('startrue');
							$(".wrap").show().delay(1500).hide(100);
                            if(cll){
                                cll.collect=!cll.collect;
                            }
						} else {
							$(".wrap").text(data.data.error);
							$(".wrap").show().delay(1500).hide(100);
						}
					})
				}

			}
		},
		watch: {
            screenWidth (val) {
                if (!this.timer) {
                    this.screenWidth = val;
                    this.timer = true;
                    let that = this;
                    setTimeout(function () {
                        if(that.IsPC()&&(val<=544)){
                            that.specail=true
                        }else{
                            that.specail=false
                        }
                        that.timer = false
                    }, 300)
                }

            }
		},
		components: {
			toast
		}

	})
</script>
<style scoped type="text/css">
    .consult_card{
        width: 23.2rem;
    }
    .collectToggle:hover{
        cursor: pointer;
    }
	.mybn a{
		border-left: none !important;
		background: #fff!important;
	}
    #home_left_list.cur{
        position: absolute;
        overflow: scroll;
        overflow-x: hidden;
        bottom: 0;
        height: inherit;
    }
    .text-secondary{
        /*width: 13rem;*/
        overflow: hidden;
        height:1rem;
        font-size:0.75rem;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(153,153,153,1)!important;
        line-height:1.06rem;
        margin-bottom: 0.6rem;
    }
    .offer:hover{
        cursor:pointer;
    }
    .reqiureClass{
        color:red;
        padding-right:5px;
    }
    @media(min-width:1600px){
        .col-my-33{
            flex: 0 0 33.33333%;
            max-width: 33.33333%;
        }
    }

    .guan{
        justify-content: space-around;
        margin: 0;
        padding: 0;
    }
    .sanliul{
        float: right;
        width: 65%;
    }
    .myBtn{
        height:30px;
        display:block;
        position:absolute;
        top:20px;
        padding:10px;
        right:20px;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:10px;
        text-align:center;
        background:rgba(242,243,244,1);
        border-radius:20px;
    }
    .myBtn:hover{
        cursor:pointer;
    }
    #home_right_list.cur{
        position: absolute;
        overflow: scroll;
        overflow-x: hidden;
        bottom: 0;
        height: inherit;
    }
</style>

